module.exports = __webpack_public_path__ + "static/media/franklin.079ccc27.png";